import React, { useState, useRef, useEffect } from 'react';
import Notification from '../../components/Notification';
import ChangePassword from '../../components/ChangePassword';
import EditAccountDetails from '../../components/EditAccountDetails';
import useApi from '../../api/useApi';
import { useStateValue } from '../../ContextApi/StateProvider';

function Account() {
  const [{ user }, dispatch] = useStateValue();

  // const { user } = JSON.parse(localStorage.user);

  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [selectedImg, setImage] = useState();
  const [selectedImgFile, selectImage] = useState();
  const [{ isLoading, isError, data }, updateImage] = useApi();
  const [state, getUpdatedUserDetails] = useApi();

  const image = useRef();

  const showNotification = (typ, msg) => {
    setType(typ);
    setMessage(msg);
    setNotification(true);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const fileChangedHandler = (event) => {
    let extention = event.target.files[0].name.split('.')[1];
    const validExtentions = ['JPG', 'JPEG', 'PNG', 'SVG'];
    if (!validExtentions.includes(extention.toUpperCase())) {
      setType('error');
      setMessage('You can upload only JPG JPEG PNG and SVG files');
      setNotification(true);
      return;
    }

    selectImage(event.target.files[0]);

    let reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  const uploadAvatar = () => {
    if (selectedImgFile) {
      const formData = new FormData();
      formData.append('file', selectedImgFile, selectedImgFile.name);

      updateImage(`/user/${user.userId}/avatar`, 'POST', formData);
    }
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setType('success');
      setMessage('User Details updated Successfully');
      setNotification(true);

      setTimeout(() => {
        getUpdatedUserDetails(`/user/${user.userId}`, 'get');
      }, 4000);
    }
    if (isError) {
      setType('error');
      setMessage('Unable to update user Details');
      setNotification(true);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      let x = {
        ...JSON.parse(localStorage.user),
        ...state.data,
      };
      dispatch({
        type: 'USER_DATA',
        user: state.data.user,
      });
      localStorage.user = JSON.stringify(x);
    }
  }, [state]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      <div className="h-screen w-topBar fixed hideScroll" style={{ left: '12%' }}>
        <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Account Settings</span>
          </div>
        </div>

        <div className="tbl h-full" style={{ minWidth: '700px' }}>
          <div className="bg-tableBg w-tableWidth m-auto pb-5" style={{ minHeight: '85%' }}>
            <div className="flex">
              <div className="w-1/4 flex flex-col items-center justify-start">
                <img
                  src={selectedImg || user.avatar + '?' + global.Date.now() || 'assets/img/placeholder.jpg'}
                  alt=""
                  className="rounded-full"
                  style={{ marginTop: '6.5rem', height: '8.5rem', width: '8.5rem' }}
                />
                {/* {isLoading ? (
                  <img src="assets/img/loader.svg" className="w-16 mx-auto" alt="" />
                ) : (
                  <> */}
                <button
                  className="rounded-lg mt-9 focus:outline-none px-4 h-10 text-textBlue1 cursor-pointer"
                  style={{ background: '#16406D33', border: '1px solid #16406D' }}
                  onClick={() => image.current.click()}
                >
                  Upload Avatar
                </button>
                <input hidden={true} ref={image} type="file" onChange={fileChangedHandler} />
                {/* </>
                )} */}
              </div>

              <div className="w-3/4 p-4">
                <EditAccountDetails showNotification={showNotification} upDateAvatar={uploadAvatar} user={user} />
                <hr className="mt-8 bg-white" />
                <ChangePassword showNotification={showNotification} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Account;
